import { useLazyContext } from "@redotech/react-util/context";
import { ConversationTagInput } from "@redotech/redo-merchant-support-app/conversation-tags/conversation-tag-input";
import { ConversationTagsContext } from "@redotech/redo-merchant-support-app/services/conversation-tags-service";
import type { HasTagCondition as HasTagConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

export const HasTagCondition = memo(function HasTagCondition({
  condition,
  onChange,
}: {
  condition: HasTagConditionType;
  onChange: (updated: HasTagConditionType) => void;
}) {
  const [conversationTags] = useLazyContext(ConversationTagsContext);

  const tagNames = useMemo(
    () => new Set(condition.tags ?? []),
    [condition.tags],
  );

  const tags = useMemo(
    () => conversationTags.value?.filter((tag) => tagNames.has(tag.name)) ?? [],
    [conversationTags.value, tagNames],
  );

  return (
    <Flex dir="column" gap="sm" w="full">
      <ConversationTagInput
        currentTags={tags}
        setCurrentTags={(updated) =>
          onChange({ ...condition, tags: updated.map((tag) => tag.name) })
        }
        showAddButtonToEnterInput
      />
    </Flex>
  );
});
